import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import Header from './header';
import Footer from './Footer';
import styles from './Allproducts.module.css';
import { openWhatsAppOrder } from '../utils/whatsapp';

const MyProduct = ({ cartItems = 0, onAddToCart, cartList = [], cartTotal = 0, showCart = false, onCartToggle = () => {}, onRemoveItem = () => {} }) => {
    const { id } = useParams();
    const [product, setProduct] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [selectedPhotoIndex, setSelectedPhotoIndex] = useState(0);



    const ORANGE_COLOR = '#3261e3ff';

    useEffect(() => {
        const fetchProduct = async () => {
            setLoading(true);
            try {
                const response = await axios.get(`/api/myproduct/${id}`);
                setProduct(response.data);
            } catch (err) {
                setError(err.message);
                console.error('Error fetching product:', err);
            } finally {
                setLoading(false);
            }
        };
        fetchProduct();
    }, [id]);

    if (loading) {
        return (
            <>
                <Header
                    cartItems={cartItems}
                    cartList={cartList}
                    cartTotal={cartTotal}
                    showCartDropdown={showCart}
                    onCartToggle={onCartToggle}
                    onRemoveItem={onRemoveItem}
                />
                <div className={styles.productsContainer}>
                    <div className={styles.loadingContainer}>Loading product...</div>
                </div>
                <Footer />
            </>
        );
    }

    if (error || !product) {
        return (
            <>
                <Header
                    cartItems={cartItems}
                    cartList={cartList}
                    cartTotal={cartTotal}
                    showCartDropdown={showCart}
                    onCartToggle={onCartToggle}
                    onRemoveItem={onRemoveItem}
                />
                <div className={styles.productsContainer}>
                    <div className={styles.errorMessage}>
                        {error || 'Product not found'}
                    </div>
                </div>
                <Footer />
            </>
        );
    }

    // Get all product photos
    const photos = [
        product.photo_url,
        product.photo_url2,
        product.photo_url3,
        product.photo_url4,
        product.photo_url5,
        product.photo_url6,
        product.photo_url7
    ].filter(Boolean);

    return (
        <>
            <Header
                cartItems={cartItems}
                cartList={cartList}
                cartTotal={cartTotal}
                showCartDropdown={showCart}
                onCartToggle={onCartToggle}
                onRemoveItem={onRemoveItem}
            />

            <br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>

            <div className={styles.productsContainer}>
                <div className={styles.pageHeader}>
                    <h1 className={styles.pageTitle}>
                        {product.item_name}
                    </h1>
                </div>

                <div className={styles.contentWrapper}>
                    <div className={styles.mainContent} style={{ maxWidth: '1000px', margin: '0 auto' }}>
                        <div style={{
                            background: 'white',
                            borderRadius: '16px',
                            padding: '40px',
                            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)'
                        }}>
                            {/* Product Info */}
                            <div style={{
                                display: 'flex',
                                gap: '12px',
                                marginBottom: '20px',
                                fontSize: '14px',
                                color: '#666',
                                fontWeight: '500',
                                textTransform: 'uppercase',
                                letterSpacing: '1.5px'
                            }}>
                                <span>{product.category}</span>
                                <span>/</span>
                                <span>{product.brand}</span>
                            </div>

                            {/* Product Condition */}
                            {product.item_condition && (
                                <div style={{
                                    fontSize: '16px',
                                    color: ORANGE_COLOR,
                                    fontWeight: '600',
                                    marginBottom: '20px'
                                }}>
                                    {product.item_condition}
                                </div>
                            )}

                            {/* Photo Gallery */}
                            <div style={{
                                margin: '30px 0',
                                background: '#f8f9fa',
                                padding: '20px',
                                borderRadius: '12px'
                            }}>
                                <img 
                                    src={photos[selectedPhotoIndex]} 
                                    alt={`${product.item_name} - ${selectedPhotoIndex + 1}`} 
                                    style={{
                                        width: '100%',
                                        maxHeight: '500px',
                                        marginBottom: '16px',
                                        borderRadius: '8px',
                                        objectFit: 'contain',
                                        backgroundColor: 'white',
                                        boxShadow: '0 4px 12px rgba(0,0,0,0.05)'
                                    }}
                                />
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    gap: '16px',
                                    flexWrap: 'wrap'
                                }}>
                                    {photos.map((photo, index) => (
                                        <img
                                            key={index}
                                            src={photo}
                                            alt={`${product.item_name} thumbnail ${index + 1}`}
                                            style={{
                                                width: '80px',
                                                height: '80px',
                                                objectFit: 'cover',
                                                borderRadius: '8px',
                                                cursor: 'pointer',
                                                border: selectedPhotoIndex === index ? '2px solid #96085d'  :  '2px solid transparent',
                                                transition: 'all 0.3s ease',
                                                backgroundColor: 'white',
                                                transform: selectedPhotoIndex === index ? 'translateY(-2px)' : 'none',
                                                boxShadow: selectedPhotoIndex === index ? '0 4px 12px rgba(209, 0, 36, 0.2)' : 'none'
                                            }}
                                            onClick={() => setSelectedPhotoIndex(index)}
                                        />
                                    ))}
                                </div>
                            </div>

                            {/* Product Description */}
                            <div style={{
                                whiteSpace: 'pre-wrap',
                                textAlign: 'left',
                                margin: '24px 0',
                                color: '#555',
                                fontSize: '1.1rem',
                                lineHeight: '1.8'
                            }}>
                                {product.item_description}
                            </div>

                            {/* Product Price */}
                            <div style={{
                                fontSize: '2rem',
                                fontWeight: '700',
                                color: ORANGE_COLOR,
                                margin: '24px 0',
                                textAlign: 'center'
                            }}>
                                {product.item_feature}
                            </div>

                            {/* Add to Cart / WhatsApp Buttons */}
                            <div style={{ marginTop: '30px', display: 'flex', gap: '16px', justifyContent: 'center', maxWidth: '480px', marginLeft: 'auto', marginRight: 'auto' }}>
                                <button
                                    onClick={() => onAddToCart({
                                        ...product,
                                        item_price: product.sell_price,
                                        quantity: 1
                                    })}
                                    title="Add to Cart"
                                    aria-label={`Add ${product.item_name} to cart`}
                                    style={{
                                        flex: '0 0 28%',
                                        padding: '16px',
                                        background: 'linear-gradient(135deg, #c1121f 0%, #e63946 100%)',
                                        color: 'white',
                                        border: 'none',
                                        borderRadius: '30px',
                                        cursor: 'pointer',
                                        fontSize: '22px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        transition: 'all 0.3s ease',
                                        boxShadow: '0 4px 15px rgba(193, 18, 31, 0.3)'
                                    }}
                                    onMouseOver={(e) => {
                                        e.currentTarget.style.background = 'linear-gradient(135deg, #e63946 0%, #c1121f 100%)';
                                        e.currentTarget.style.transform = 'translateY(-2px)';
                                        e.currentTarget.style.boxShadow = '0 6px 20px rgba(193, 18, 31, 0.4)';
                                    }}
                                    onMouseOut={(e) => {
                                        e.currentTarget.style.background = 'linear-gradient(135deg, #c1121f 0%, #e63946 100%)';
                                        e.currentTarget.style.transform = 'translateY(0)';
                                        e.currentTarget.style.boxShadow = '0 4px 15px rgba(193, 18, 31, 0.3)';
                                    }}
                                >
                                    <i className="fa fa-cart-plus" aria-hidden="true"></i>
                                </button>
                                <button
                                    onClick={() => openWhatsAppOrder(product)}
                                    style={{
                                        flex: '1 1 70%',
                                        padding: '16px 24px',
                                        background: '#6c757d',
                                        color: 'white',
                                        border: 'none',
                                        borderRadius: '30px',
                                        cursor: 'pointer',
                                        fontSize: '18px',
                                        fontWeight: '600',
                                        transition: 'all 0.3s ease',
                                        textTransform: 'uppercase',
                                        letterSpacing: '1px',
                                        boxShadow: '0 4px 15px rgba(90, 98, 104, 0.3)',
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        gap: '8px'
                                    }}
                                    onMouseOver={(e) => {
                                        e.currentTarget.style.background = '#5a6268';
                                        e.currentTarget.style.transform = 'translateY(-2px)';
                                        e.currentTarget.style.boxShadow = '0 6px 20px rgba(90, 98, 104, 0.4)';
                                    }}
                                    onMouseOut={(e) => {
                                        e.currentTarget.style.background = '#6c757d';
                                        e.currentTarget.style.transform = 'translateY(0)';
                                        e.currentTarget.style.boxShadow = '0 4px 15px rgba(90, 98, 104, 0.3)';
                                    }}
                                >
                                    <i className="fa fa-whatsapp" aria-hidden="true"></i> Order via WhatsApp
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <br/><br/><br/><br/><br/><br/>

            <Footer />
        </>
    );
};

export default MyProduct;
